import React from "react";
import { ReactNode } from "react";

interface Props {
  graph: ReactNode;
  legend: ReactNode;
}

export default function (props: Props) {
  return (
    <div className="row">
      <div className="col-12 col-lg-7">{props.graph}</div>
      <div className="col-12 col-lg-5 d-flex flex-column justify-content-center gap-sm">
        {props.legend}
      </div>
    </div>
  );
}
